<!--檢前提醒-->
<div class="page-container reserve-confirm-content">
  <!--title 標題-->
  <div class="page-title-block">
    <h2 class="page-title">
      {{ 'reserve-confirm-reminder.title' | translate }}
    </h2>
    <div class="page-subtitle-block">
      <img
        width="26"
        height="26"
        ngSrc="assets/img/i-clock-user.svg"
        alt="clock-user"
      />
      <div>
        <p class="page-subtitle-block-title">
          {{ 'reserve-confirm-reminder.hint-title' | translate }}
        </p>
        <p>{{ 'reserve-confirm-reminder.hint-message' | translate }}</p>
      </div>
    </div>
  </div>

  <div class="card-content register-card-content">
    @for (reminder of reminderList; let i = $index; track i) {
      <h3 class="register-card-title">{{ getReminderExamTitle(reminder) }}</h3>
      <div class="input-block">
        <div [innerHTML]="reminder.reminderText"></div>
      </div>

      <div class="agree-btn-block">
        <mat-checkbox [(ngModel)]="agreeChecked[i]">
          {{ 'reserve-confirm-reminder.read-and-agree' | translate }}
        </mat-checkbox>
      </div>
    }
  </div>

  <!--頁面：固定按鈕區塊-->
  <div class="page-btn-block">
    <button
      mat-button
      class="btn-fill-primary btn-size-l"
      [disabled]="!allAgree()"
      (click)="confirm()"
    >
      {{ 'common.button.confirm' | translate }}
    </button>
  </div>
</div>
